<div *ngIf="modelValue?.length" class="messages">
	<div
		class="imessage"
		*ngFor="let message of modelValue"
	>
		<div class="remove-message" (click)="removeMessage(message)">
			<i class="fa fa-trash"></i>
		</div>
		<div class="imessage-name">
			{{ message.name }}
		</div>
		<div *ngIf="message?.procedures" class="procedures">
			<div
				*ngFor="let procedure of message.procedures"
				class="procedure"
			>
				<div class="procedure-type">
					{{ procedure.entity }}
				</div>
				<div class="actions">
					<div *ngFor="let action of procedure.actions" class="action">
						<textarea [(ngModel)]="action.parameters[0].value" name="parameter-value" (ngModelChange)="onParameterChanged($event, 0)" placeholder="javascript to execute"></textarea>
					</div>
					<!-- <div class="add-action button" (click)="addAction(procedure)">
						Add action
					</div> -->
				</div>
			</div>
		</div>
	</div>
</div>
<div class="add-message">
	<div class="text">
		Add message handler:
	</div>
	<bb-entity-selector 
		[(ngModel)]="eventName"
		(optionSelected)="onEventSelected($event)"
		[extendable]="true"
		[options]="eventList"
		[selectOnly]="true"
		name="eventList"
		class="event-selector"
	></bb-entity-selector>

</div>
